import * as requestFromServer from './productsCrud';
import {productsSlice, callTypes} from "./productsSlice";

const {actions} = productsSlice;

export const fetchProducts = queryParams => dispatch =>{
    dispatch(actions.startCall({callType: callTypes.list}));
    
    return requestFromServer
        .findProducts(queryParams)
        .then(response =>{
            const {totalCount, entities} = response.data;
            dispatch(actions.productsFetched({totalCount, entities}));
        })
        .catch(error =>{
            dispatch(actions.catchError({error, callType: callTypes.list}));
        })
}


export const fetchProduct = id => dispatch =>{
    dispatch(actions.startCall({callType: callTypes.action}));
    
    return requestFromServer
        .getProductById(id)
        .then(response =>{
            const product =response.data;
            dispatch(actions.productFetched({productForEdit: product}));
        })
        .catch(error =>{
            dispatch(actions.catchError({error, callType: callTypes.action}));
        })
}

export const fetchCategories = () => dispatch => {
    dispatch(actions.startCall({callType: callTypes.list}));
    
    return requestFromServer
        .getCategories()
        .then(response =>{
            const categories = response.data;
            dispatch(actions.productCategoriesLoaded({categories}));
        })
        .catch(error =>{
            dispatch(actions.catchError({error, callType: callTypes.list}));
        })
}

export const reloadProducts = () => dispatch =>{
    dispatch(actions.startCall({callType: callTypes.action}));
    
    return requestFromServer
        .fetchProducts()
        .then(() =>{
            dispatch(actions.productsReloaded())
        })
        .catch(error =>{
            dispatch(actions.catchError({error, callType: callTypes.action}));
        })
}


export const updateProduct = product => dispatch =>{
    dispatch(actions.startCall({callType: callTypes.action}));
    
    return requestFromServer
        .updateProduct(product)
        .then(response =>{
            const product =  response.data;
            dispatch(actions.productUpdated({product}));
        })
    
}